import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

export const echo = new Echo({
  broadcaster: "pusher",
  key: process.env.REACT_APP_PUSHER_APP_KEY,
  cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
  wsHost: process.env.REACT_APP_PUSHER_WS_HOST,
  wsPort: 8080,
  wssPort: 443,
  disableStats: true,
  encrypted: true,
  forceTLS: false
});
